import React from 'react';
import { Container } from '@mui/material';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';
import { SttFullDialog } from '../../../sporttia/all';
import SalePointBody from './SalePointBody';
import { useSalePoint } from './useSalePoint';

type Props = {
    open?: boolean;
    idTicket: string | number;
    onClose: () => void;
    urlPath?: string;
};

/**
 * Punto de venta como diálogo a pantalla completa. Es la forma de abrir un
 * ticket ya existente desde el listado; el punto de venta del día a día vive en
 * su propia página (`SalePointPage`).
 */
export default function SalePoint({
    open = false,
    idTicket,
    onClose,
    urlPath,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const salePoint = useSalePoint({ idTicket, onClose });

    return (
        <SttFullDialog
            open={open}
            onClose={salePoint.requestClose}
            title={t('PointOfSale')}
            urlPath={urlPath}
            buttons={[
                {
                    show:
                        salePoint.previousPurchaseTicket &&
                        salePoint.previousPurchaseTicket?.status === 'CLOSE',
                    caption: t('Print'),
                    onClick: () => salePoint.downloadTicket(),
                    icon: <ConfirmationNumberIcon />,
                },
            ]}
            menu={
                salePoint.canDeleteTicket
                    ? [
                          {
                              caption: t('Delete'),
                              icon: <HighlightOffIcon />,
                              onClick: () => salePoint.deleteTicket(),
                          },
                      ]
                    : undefined
            }
        >
            {/* El diálogo va de borde a borde: aquí sí toca centrar y limitar
                el ancho del contenido. */}
            <Container>
                <SalePointBody salePoint={salePoint} />
            </Container>
        </SttFullDialog>
    );
}
